//
// Module for the Effective Permissions Listing page in the Security section
//
rs.module("security/listings/effectivepermissions",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors) {

            var form = $.js(jsSelectors.form);
            var appUserSelect = form.js(jsSelectors.appUserSelect);
            var appUserDisplayNameHidden = form.js(jsSelectors.appUserDisplayNameHidden);
            var loadingSpinner = form.js(jsSelectors.loadingSpinner);

            // On app user selection change, set hidden field to capture the selected app user's display name
            appUserSelect.change(function () {
                appUserDisplayNameHidden.val(appUserSelect.find(":selected").text());
            });

            // Show the loading spinner when the View button is clicked and the form is submitted
            form.on("formdata", function (e) {
                loadingSpinner.show();
            });
        }

        // Exported public API
        var exports = {
            initialize
        };

        return exports;
    }
);